import { useMutation } from 'urql';
import {
  AddressTitle,
  CreateUserDto,
  ModulePrivileges,
} from '../../gql/graphql.ts';
import React, { useState } from 'react';
import { graphql } from '../../gql/index.ts';
import { useNavigate } from '@tanstack/react-router';
import { UserForm, UserFormSubmitData } from './UserForm.tsx';
import { describeUserBackendError } from './errorTranslations.ts';
import { Alert } from '../../shared/Alert.tsx';

interface UserNewPageProps {
  companyId: string;
}

const AddUserMutation = graphql(/* GraphQL */ `
  mutation createUser($user: CreateUserDto!) {
    createUser(user: $user) {
      id
    }
  }
`);

export const UserNewPage: React.FC<UserNewPageProps> = ({ companyId }) => {
  const [, addUser] = useMutation(AddUserMutation);
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const onFormSubmit = ({ formData }: UserFormSubmitData) => {
    setError(null);
    addUser({
      user: {
        ...formData,
        companyId,
        password: formData.password ?? 'ERROR',
      } as CreateUserDto,
    }).then((result) => {
      if (result.error) {
        setError(
          describeUserBackendError(
            result.error,
            'Benutzer konnte nicht angelegt werden.',
          ),
        );
        return;
      }
      navigate({ to: '/admin/users' });
    });
  };

  return (
    <>
      {error && (
        <Alert type="error" icon="ExclamationTriangle" className="mb-4">
          {error}
        </Alert>
      )}
      <UserForm
        value={{
          address: { title: AddressTitle.Mr, email: '' },
          privileges: [ModulePrivileges.Member],
        }}
        onSubmit={onFormSubmit}
        showPassword={true}
      />
    </>
  );
};
